import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Chat, ChatMetadata, ChatState } from '../../interfaces/taraInterfaces';

const initialState: ChatState = {
  allChatsHistory: [],
  hasFetchedTaraChatHistory: false,
  currentChat: null,
  isBotTyping: false,
  historyLoading: 'null',
  showGraphsOnly: false,
  showDeepInsights: false,
  streamingStatusMessages: [],
  previousResponseId: null,
  canChat: true,
  currentTokenCount: null,
  currentChatInfo: {
    chatTokenCount: 0,
  },
  activeMCPs: [],
  selectedOpenAiModel: 'gpt-5.1-chat-latest',
  lastUsedMCPs: [],
};

export const chatSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    setAllChatsHistory: (state, action: PayloadAction<ChatMetadata[]>) => {
      state.allChatsHistory = action.payload;
    },
    setCurrentChat: (state, action: PayloadAction<Chat | null>) => {
      state.currentChat = action.payload;
    },
    setIsBotTyping: (state, action: PayloadAction<boolean>) => {
      state.isBotTyping = action.payload;
    },
    setHistoryLoading: (
      state,
      action: PayloadAction<'pending' | 'success' | 'error' | 'null'>
    ) => {
      state.historyLoading = action.payload;
    },
    toggleShowGraphsOnly: (state) => {
      state.showGraphsOnly = !state.showGraphsOnly;
    },
    toggleShowDeepInsights: (state) => {
      state.showDeepInsights = !state.showDeepInsights;
    },
    setSelectedOpenAiModel: (state, action: PayloadAction<string>) => {
      state.selectedOpenAiModel = action.payload;
    },
    setCanChat: (state, action: PayloadAction<boolean>) => {
      state.canChat = action.payload;
    },
    setCurrentTokenCount: (state, action: PayloadAction<number | null>) => {
      state.currentTokenCount = action.payload;
    },
    setCurrentChatInfo: (state, action: PayloadAction<any>) => {
      state.currentChatInfo = action.payload;
    },
    setStreamingStatusMessages: (state, action: PayloadAction<string>) => {
      if (!state.streamingStatusMessages) {
        state.streamingStatusMessages = [];
      }
      state.streamingStatusMessages.push(action.payload);
    },
    setPreviousResponseId: (state, action: PayloadAction<string | null>) => {
      state.previousResponseId = action.payload;
    },
    clearStreamingStatusMessages: (state) => {
      state.streamingStatusMessages = [];
    },
    setActiveMCPIntegrations: (state, action: PayloadAction<any[]>) => {
      state.activeMCPs = action.payload;
    },
    setLastUsedMCPs: (state, action: PayloadAction<string[]>) => {
      state.lastUsedMCPs = action.payload;
    },
    setHasFetchedTaraChatHistory: (state, action: PayloadAction<boolean>) => {
      state.hasFetchedTaraChatHistory = action.payload;
    },
    clearChatSlice: (state) => {
      state.allChatsHistory = [];
      state.hasFetchedTaraChatHistory = false;
      state.currentChat = null;
      state.isBotTyping = false;
      state.historyLoading = 'null';
      state.showGraphsOnly = false;
      state.showDeepInsights = false;
      state.streamingStatusMessages = [];
      state.previousResponseId = null;
      state.canChat = true;
      state.currentTokenCount = null;
      state.currentChatInfo = {
        chatTokenCount: 0,
      };
      state.activeMCPs = [];
      state.lastUsedMCPs = [];
    },
  },
});

export const {
  setAllChatsHistory,
  setHasFetchedTaraChatHistory,
  setCurrentChat,
  setIsBotTyping,
  setHistoryLoading,
  clearChatSlice,
  toggleShowGraphsOnly,
  toggleShowDeepInsights,
  setSelectedOpenAiModel,
  setStreamingStatusMessages,
  clearStreamingStatusMessages,
  setPreviousResponseId,
  setCanChat,
  setCurrentTokenCount,
  setCurrentChatInfo,
  setActiveMCPIntegrations,
  setLastUsedMCPs,
} = chatSlice.actions;
export const chatReducer = chatSlice.reducer;
